import type { ApiTransportador } from "thirdParty/transportadores/types/ApiTransportador";
import type { ApiProdutor } from "pages/produtores/types/ApiProdutor";
import { DATE_API_FORMAT } from "std/const/date";
import type { ApiRelatorioGetParams, ApiRelatorioParams } from "../types/ApiRelatorioParams";

function parseCodigo(value: string | number | null | undefined): number | undefined {
	if (value == null || value === "") {
		return undefined;
	}

	const parsed = Number(value);

	return Number.isNaN(parsed) ? undefined : parsed;
}

function buildCodRange(items: Array<string | number | null | undefined>): { start?: string; end?: string } {
	const values = items.map(parseCodigo).filter((value): value is number => value != null);

	if (values.length === 0) {
		return {};
	}

	return {
		start: String(Math.min(...values)),
		end: String(Math.max(...values)),
	};
}

function joinIds(values: number[]): string | undefined {
	if (values.length === 0) {
		return undefined;
	}

	return values.join(",");
}

export function buildRelatorioGetParams(filter: Optional<ApiRelatorioParams>): ApiRelatorioGetParams {
	const produtores: ApiProdutor[] = filter?.filterProdutores ?? [];
	const transportadores: ApiTransportador[] = filter?.filterTransportadores ?? [];

	const produtorCodRange = buildCodRange(produtores.map((produtor) => produtor.for_codigoindividual));
	const transportadorCodRange = buildCodRange(transportadores.map((transportador) => transportador.tra_codigoindividual));

	return {
		filterDataInicio: filter?.filterData?.start.format(DATE_API_FORMAT),
		filterDataFim: filter?.filterData?.end.format(DATE_API_FORMAT),
		filterProdutorIdpk: joinIds(produtores.map((produtor) => produtor.for_idpk)),
		filterProdutorCodInicio: produtorCodRange.start,
		filterProdutorCodFim: produtorCodRange.end,
		filterTransportadorIdpk: joinIds(transportadores.map((transportador) => transportador.tra_idpk)),
		filterTransportadorCodInicio: transportadorCodRange.start,
		filterTransportadorCodFim: transportadorCodRange.end,
		filterCnpjCpf: filter?.filterCnpjCpf,
		filterCidadeIdpk: filter?.filterCidade?.cid_idpk,
		filterEstado: filter?.filterEstado,
		filterBancoIdpk: filter?.filterBancoIdpk,
		filterEmpConvIdpk: filter?.filterEmpConvIdpk,
		filterRotaIdpk: filter?.filterRota?.rot_idpk,
		filterTipo: filter?.filterTipo,
		filterTipoCrio: filter?.filterTipoCrio,
		filterTipoConv: filter?.filterTipoConv,
		filterMesRef: filter?.filterMesRef,
		filterThresholdPct: filter?.filterThresholdPct,
		filterCompareDays: filter?.filterCompareDays,
		filterFaixasIds: filter?.filterFaixasIds?.join(","),
		orderby: filter?.orderby,
	};
}
